import React, { createContext, useState } from 'react'

export const addcontext = createContext()
function ContextShare({children}) {
    const [isFilterOpen,setFilterOpen]=useState(false)
    const [isFilterOpenC,setFilterOpenC]=useState(false)
    const [paginationForGovernerAddress,setPaginationForGovernerAddress]=useState(10)
    //initialzes the table selected from sidebar to video
    //tableSelectedFromSidebar is used in ManageVideos.jsx, Sidebar.jsx
    const [tableSelectedFromSidebar,settableSelectedFromSidebar]=useState('home')
    const [videoUrl,setVideoUrl]=useState('')
    const [videoThumb,setVideoThumb]=useState('')
    const [videoData,setVideoData]=useState()
    const [whichPageIsSendingData,setwhichPageIsSendingData]=useState()
    const [filterSearchResults,setFilterSearchResults]=useState()
    const [isPartAVailable,setIsPartAVailable]=useState()
    const [archivesPaginationTotal,setarchivesPaginationTotal]=useState()
    const [archivesPaginationStart,setarchivesPaginationStart]=useState()
    const [archivesPaginationEnd,setarchivesPaginationEnd]=useState()
    const [addVideo,setAddVideo]=useState()
    const [changeSeqNo,setChangeSeqNo]=useState()
    const [initalDateVideoAddPage,setinitalDateVideoAddPage]=useState()
    const [addSession,setAddSession]=useState()
    const [addMember,setaddMember]=useState()
    const [addKLA,setaddKLA]=useState()
    const [addEvent,setaddEvent]=useState()
    const [addConstituency,setaddConstituency]=useState()
    const [addRole,setaddRole]=useState()
    const [addSalutation,setaddSalutation]=useState()
    const [addGovAddress,setaddGovAddress]=useState()
    const [addBudSpeech,setaddBudSpeech]=useState()
    const [addrulings,setaddrulings]=useState()
    const [changeSeqNoGA,setChangeSeqNoGA]=useState()
    const [changeSeqNoBS,setChangeSeqNoBS]=useState()
    const [changeSeqNoRL,setChangeSeqNoRl]=useState()
    const [InitialSearchQuery,setInitialSearchQuery]=useState()
    const [isSessionOpen, setisSessionOpen]=useState()
    const [isGeneral, setisGeneral]=useState()
    const [filterMembersTable,setfilterMembersTable]=useState()
    const [isPartClicked,setisPartClicked]=useState(1)
    const [newIdP,setnewIdP]=useState(1)
    const [langChanged,setlangChanged]=useState(1)
    const [isMemberOpen,setIsMemberOpen]=useState()
    const [isSidebarCloses,setIsSidebarCloses]=useState(false)
    const [searchError,setSearchError]=useState()
    const [selectedButton, setSelectedButton] = useState('al');
    const [GASearchQuery,setGASearchQuery]=useState()
    const [BSSearchQuery,setBSSearchQuery]=useState()
    const [RLearchQuery,setRLSearchQuery]=useState()
    const [paginationStartIndex,setPaginationStartIndex]=useState(1)
    const [paginationEndIndex,setPaginationEndIndex]=useState(10)
    const [totalSearchResults,seTtotalSearchResults]=useState()
    const [isSearchOrAdSearch,setIsSearchOrAdSearch]=useState()
    const [totalSearchResultsNS,seTtotalSearchResultsNS]=useState()
    const [paginationStartIndexAD,setPaginationStartIndexAD]=useState(1)
    const [paginationEndIndexAD,setPaginationEndIndexAD]=useState(25)
    const [addReservation, setaddReservation]=useState()
    const [isFlowModalOpened,setIsFlowModalOpened]=useState(true)
    const [addUser,setAddUser] = useState()

  return (
    <addcontext.Provider value={{isFilterOpenC,setFilterOpenC,tableSelectedFromSidebar,settableSelectedFromSidebar,paginationForGovernerAddress,setPaginationForGovernerAddress,videoUrl,setVideoUrl,videoThumb,setVideoThumb,videoData,setVideoData,whichPageIsSendingData,setwhichPageIsSendingData,filterSearchResults,setFilterSearchResults,isPartAVailable,setIsPartAVailable,archivesPaginationTotal,setarchivesPaginationTotal,archivesPaginationStart,setarchivesPaginationStart,archivesPaginationEnd,setarchivesPaginationEnd,addVideo,setAddVideo,isFilterOpen,setFilterOpen,changeSeqNo,setChangeSeqNo,initalDateVideoAddPage,setinitalDateVideoAddPage,addSession,setAddSession,addMember,setaddMember,addKLA,setaddKLA,addEvent,setaddEvent,addConstituency,setaddConstituency,addRole,setaddRole,addSalutation,setaddSalutation,addGovAddress,setaddGovAddress,addBudSpeech,setaddBudSpeech,addrulings,setaddrulings,changeSeqNoGA,setChangeSeqNoGA,changeSeqNoBS,setChangeSeqNoBS,changeSeqNoRL,setChangeSeqNoRl,InitialSearchQuery,setInitialSearchQuery,isSessionOpen, setisSessionOpen,isGeneral, setisGeneral,filterMembersTable,setfilterMembersTable,isPartClicked,setisPartClicked,newIdP,setnewIdP,langChanged,setlangChanged,isMemberOpen,setIsMemberOpen,isSidebarCloses,setIsSidebarCloses,searchError,setSearchError,selectedButton, setSelectedButton,GASearchQuery,setGASearchQuery,BSSearchQuery,setBSSearchQuery,RLearchQuery,setRLSearchQuery,paginationStartIndex,setPaginationStartIndex,paginationEndIndex,setPaginationEndIndex,totalSearchResults,seTtotalSearchResults,isSearchOrAdSearch,setIsSearchOrAdSearch,totalSearchResultsNS,seTtotalSearchResultsNS,paginationStartIndexAD,setPaginationStartIndexAD,paginationEndIndexAD,setPaginationEndIndexAD,addReservation, setaddReservation,isFlowModalOpened,setIsFlowModalOpened,addUser,setAddUser}}>
        {children}
    </addcontext.Provider>
  )
}

export default ContextShare